import { FC } from 'react';
import { Link } from '@zoopla-eng/zds-components/link';
import triggerTracking from '@blueprint/tracking/dist/Tracking';

import RegisterForm from './RegisterForm';
import { TermsText } from '../../AuthModal.styles';
import { SocialAuthProps } from '../../AuthModal.types';

type RegisterSectionProps = Pick<
    SocialAuthProps,
    | 'close'
    | 'actionAfterAuth'
    | 'resetActionAfterAuth'
    | 'onSocialAuth'
    | 'setCurrentStep'
>;

const RegisterSection: FC<React.PropsWithChildren<RegisterSectionProps>> = ({
    close,
    actionAfterAuth,
    resetActionAfterAuth,
    onSocialAuth,
    setCurrentStep
}) => (
    <>
        <RegisterForm
            close={close}
            actionAfterAuth={actionAfterAuth}
            resetActionAfterAuth={resetActionAfterAuth}
            onSocialAuth={onSocialAuth}
            setCurrentStep={setCurrentStep}
        />
        <TermsText>
            By registering you accept our{' '}
            <Link
                key="terms"
                data-testid="terms-link"
                href="/terms/"
                onClick={() => {
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: 'registration',
                        eventAction: 'click_to_terms',
                        eventLabel: actionAfterAuth?.eventLabel
                    });
                }}
            >
                Terms of Use
            </Link>{' '}
            and{' '}
            <Link
                key="privacy"
                data-testid="privacy-link"
                href="/privacy/"
                onClick={() => {
                    triggerTracking({
                        event: 'GAEvent',
                        eventCategory: 'registration',
                        eventAction: 'click_to_privacy',
                        eventLabel: actionAfterAuth?.eventLabel
                    });
                }}
            >
                Privacy Policy
            </Link>
            .
        </TermsText>
    </>
);

export default RegisterSection;
